import React, { useState, useEffect } from "react";
import FooterUtente, { infoUtente, loadFooter } from "../../visualComponents/FooterUtente";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Loader from "../../visualComponents/Loader.js";
import NavBar from "../../visualComponents/NavBarGenerale.js";

let isLoading = false;
let idComponente = null;

const ImgPreview = ({ isVisible, setIsVisible, img }) => {

    if (!isVisible) return null;

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back"
            onClick={() => setIsVisible(false)}
        >
            <div className="p-4 rounded-lg" style={{ maxWidth: "90vw", maxHeight: "90vh" }}>
                <img
                    src={img}
                    alt="Preview"
                    className="max-w-full max-h-[80vh] mx-auto block rounded-md"
                />
            </div>
        </div>
    );
};

const FotoUtente = () => {
    const [filter, setFilter] = useState("");
    const [data, setData] = useState([]);
    const [viewData, setViewData] = useState([]);
    const [isImgVisible, setIsImgVisible] = useState(false);
    const [img, setImg] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        setViewData(
            filter === ""
                ? data
                : data.filter((e) => {
                    const searchTerm = filter.toLowerCase();
                    return (
                        e["PathFoto"].split("/").pop().toLowerCase().includes(searchTerm) ||
                        e["Descrizione"].toLowerCase().includes(searchTerm) ||
                        e["Timestamp"].toLowerCase().includes(searchTerm) ||
                        e["NomeUtente"].toLowerCase().includes(searchTerm) ||
                        e["CognomeUtente"].toLowerCase().includes(searchTerm)
                    );
                })
        );
    }, [filter, data]);

    const onload = async () => {

        let tempId = null;

        try {
            isLoading = true;

            await loadFooter();

            if (document.cookie.split("IDComponente=").length > 1) {
                idComponente = document.cookie.split("IDComponente=")[1].split(";")[0];
                tempId = document.cookie.split("IDComponente=")[1].split(";")[0];
                document.cookie = "IDComponente=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

                const r1 = await fetch('/getFotos', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente.CodiceDominio,
                        IDComponente: tempId
                    }),
                });

                const rd1 = await r1.json();

                if (r1.status !== 200) {
                    alert(rd1.error);
                    console.error(rd1.error);
                    navigate("/dashUtente");
                }
                else {
                    console.log("FotoUtente: ", rd1);
                    setData(rd1);
                    isLoading = false;
                }
            }
        } catch (error) {
            alert("Errore durante il caricamento delle foto. Riprova più tardi.");
            console.log(error);
            navigate("/dashUtente");
        }
    };

    const handleFotoClick = async (path) => {
        try {
            const r = await fetch('/getImage', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    PathFoto: path,
                })
            });

            if (r.status !== 200) {
                const rd = await r.json();
                alert(rd.error);
                console.error(rd.error);
            }
            else {
                const blob = await r.blob();
                const url = URL.createObjectURL(blob);
                console.log("URL immagine:", url);
                setImg(url);
                setIsImgVisible(true);
            }
        }
        catch (error) {
            console.error("Errore nel caricamento dell'immagine:", error);
            alert("Errore nel caricamento dell'immagine. Riprova più tardi.");
        }
    };

    return (
        <div className="min-h-screen bg-white dark:bg-gray-800">
            <NavBar page="FOTO" />
            {isLoading && <Loader />}
            <div className="bg-white dark:bg-gray-800 text-black dark:text-white mb-20 pt-[4rem]">
                <div className="flex items-center p-4">
                    <button
                        className="text-black dark:text-white "
                        onClick={() => {
                            document.cookie = "IDComponente=" + idComponente + "; path=/";
                            navigate("/dashUtente/scan");
                        }}
                    >
                        <ArrowLeft size={24} />
                    </button>
                    <h1
                        className="pl-2 text-xl font-bold"
                        onClick={() => {
                            document.cookie = "IDComponente=" + idComponente + "; path=/";
                            navigate("/dashUtente/scan");
                        }}
                    > Foto Utente</h1>
                </div>
                <input
                    type="text"
                    placeholder="Filtra foto..."
                    className="w-[90%] p-2 border border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white mx-1"
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                />
                <div className="mt-1 mx-1">
                    {viewData.length > 0 ? (
                        viewData.map((e, index) => (
                            <>
                                <div className="grid grid-cols-2 p-1 my-2 border-2 border-black dark:border-white hover:cursor-pointer rounded-md" onClick={() => handleFotoClick(e["PathFoto"])} key={index}>
                                    <div className="self-center font-bold">{e["PathFoto"].split("/").pop()}</div>
                                    <div className="self-center text-right">{e["Timestamp"]}</div>
                                    <div className="self-center">{e["Descrizione"]}</div>
                                    <div className="self-center text-right italic">{`${e["CognomeUtente"]} ${e["NomeUtente"]}`}</div>
                                </div>
                                <ImgPreview isVisible={isImgVisible} setIsVisible={setIsImgVisible} img={img} />
                            </>
                        ))
                    ) : (
                        <p className="text-center">Nessuna foto trovata.</p>
                    )}
                </div>
                <FooterUtente />
            </div>
        </div >
    );
};

export default FotoUtente;